<template>
    <el-dialog :title="sname" :visible.sync="visible" :before-close="handleClose" width="960px" :close-on-click-modal="false">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="productName" label="产品" min-width="180" align="center">
                <template slot-scope="{row}">
                    <el-select v-model="row.productId" placeholder="请选择" size="small" @change="productIdChange($event, row)" v-if="row.newflag">
                        <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <span v-else>{{ row.productName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="versionName" label="版本" min-width="120" align="center">
                <template slot-scope="{row}">
                    <!-- 版本可编辑：历史订购可补录/修改版本 -->
                    <el-select v-if="!row.disabled" v-model="row.versionId" placeholder="请选择版本" size="small" clearable @focus="loadVersionOptions(row.productId)">
                        <el-option v-for="item in (productVersionMap[row.productId] || [])" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <span v-else>{{ row.versionName || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="userName" label="负责销售" min-width="110" align="center">
                <template slot-scope="{row}">
                    <!-- 市场支持的账号type=5，可以修改销售人员 -->
                    <div v-if="$store.state.userData.type === 5">
                        <el-select v-model="row.userId" placeholder="请选择" size="small">
                            <el-option v-for="item in salePersonOption.slice(1)" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div v-else>{{ row.userName }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="orderType" label="状态" min-width="140" align="center">
                <template slot-scope="{row}">
                    <el-select v-if="!row.disabled" v-model="row.orderType" placeholder="请选择" size="small" clearable>
                        <el-option v-for="item in orderTypeList.slice(1)" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <span v-else>{{ getOrderType(row.orderType) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="endDay" label="到期时间" min-width="160" align="center">
                <template slot-scope="{row}">
                    <el-date-picker v-if="!row.disabled" v-model="row.endDay" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" size="small"
                        style="width: 100%;"></el-date-picker>
                    <span v-else>{{ row.endDay }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
                <template slot-scope="{$index, row}">
                    <el-button type="text" @click="handleRowDel($index, row)" :disabled="row.disabled" style="padding: 0;">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 新增按钮 -->
        <div class="add-btn" @click="handleAdd"><i class="el-icon-plus"></i></div>
        <!-- 底部按钮 -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="save" :loading="loadSave">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { updateSchoolProduct, findProductVersionList } from "@/api/customer/index.js";
import { mapState } from "vuex";
export default {
    props: {
        visible: {
            type: Boolean,
            default: true,
        },
        data: Array,
        sid: String,
        sname: String,
    },
    data() {
        return {
            tableData: [],
            loadSave: false,
            productVersionMap: {}, // 产品id -> 版本选项列表
        };
    },
    computed: {
        ...mapState(["productList", "orderTypeList", "schoolList", "salePersonOption"]), // 映射 state.count 到组件中的 computed 属性
    },
    watch: {
        visible: {
            handler(val) {
                if (val) {
                    this.tableData = this.$utils.deepCopy(this.data);
                    this.tableData.forEach(item => {
                        // 市场支持(5)、管理员(999)可操作全部行，其他账号只能操作自己的记录
                        item.disabled = (this.$store.state.userData.userId !== item.userId) && (this.$store.state.userData.type !== 5) && (this.$store.state.userData.type !== 999);
                        // 预加载已存在产品的版本选项，支持历史订购补录版本
                        this.loadVersionOptions(item.productId);
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        getOrderType(type) {
            if (type == 0) {
                return "试用";
            } else if (type == 1) {
                return "订购";
            } else if (type == 2) {
                return "交流";
            } else if (type == 3) {
                return "停订";
            } else if (type == 4) {
                return "合作院校";
            } else if (type == 5) {
                return "赠送";
            } else if (type == 6) {
                return "后付款";
            } else {
                return ''
            }
        },
        // 点击新增一行
        handleAdd() {
            let lastRow = this.tableData[this.tableData.length - 1];
            if (lastRow && lastRow.newflag && lastRow.productId === '') {
                this.$MessageBox.MessageWarning("请填写");
            } else {
                let temp = {
                    endDay: '',
                    productId: '',
                    versionId: null,
                    productName: '',
                    orderType: '',
                    newflag: true, // 表示是新增的
                    userId: '',
                    userName: '',
                    showFlag: null, // 等于0表示可以删除，1和null都不能删
                };
                // 防止市场账号不在选项当中，查询后再赋值
                let sale = this.salePersonOption.slice(1).find(x => x.id === this.$store.state.userData.userId);
                if (sale) {
                    temp.userId = sale.id;
                    temp.userName = sale.name;
                }
                this.tableData.push(temp);
            }
        },
        // 点击表格每一行的删除
        handleRowDel(index, row) {
            let accountUserId = this.$store.state.userData.userId;
            let accountUserType = this.$store.state.userData.type;

            if (row.showFlag === 0 || row.newflag || row.userId === accountUserId || accountUserType === 999) {
                // 可以删除的情况：showFlag=0 | newflag表示新增的 | 负责销售是当前账号 | 管理员
                this.tableData.splice(index, 1);
            } else {
                this.$MessageBox.MessageWarning("该销售的客户无法删除");
            }
        },
        // 新增行选择产品：清空版本并加载版本选项（同一产品不同版本允许并存）
        productIdChange(val, row) {
            row.versionId = null;
            this.loadVersionOptions(val);
        },
        // 加载产品版本选项（带缓存）
        loadVersionOptions(productId) {
            if (productId && !this.productVersionMap[productId]) {
                findProductVersionList({ productId })
                    .then((res) => {
                        this.$set(this.productVersionMap, productId, res.data || []);
                    })
                    .catch(() => {
                        this.$set(this.productVersionMap, productId, []);
                    });
            }
        },
        // 保存编辑的产品
        save() {
            // 校验是否有空项
            let emptyFlag = false;
            this.tableData.forEach(item => {
                // “到期时间”必填：orderType = 1“订购” | 0“试用” | 5“赠送” | 6“后付款”
                if (item.productId === '' || item.userId === '' || (!item.endDay && [0, 1, 5, 6].indexOf(item.orderType) > -1)) {
                    emptyFlag = true;
                }
            })
            if (emptyFlag) {
                this.$MessageBox.MessageWarning("请检查是否存在未设置的产品");
                return;
            }
            // 校验产品+版本组合是否重复
            let keySet = new Set();
            for (let item of this.tableData) {
                let key = item.productId + '_' + (item.versionId || '');
                if (keySet.has(key)) {
                    this.$MessageBox.MessageWarning("同一产品的相同版本不能重复添加");
                    return;
                }
                keySet.add(key);
            }
            this.loadSave = true;
            updateSchoolProduct({
                schoolIdList: [this.sid],
                schoolProductModelList: this.tableData
            }).then(() => {
                this.$MessageBox.MessageSuccess("编辑成功");
                this.$emit('updateList')
                this.handleClose();
                this.loadSave = false;
            }).catch((err) => {
                this.$MessageBox.MessageWarning(err.data.msg);
                this.loadSave = false;
            });
        },
        handleClose() {
            this.$emit("update:visible", false);
        },
    },
};
</script>

<style lang="scss" scoped>
.add-btn {
    width: 100%;
    height: 44px;
    background-color: #f5f7fa;
    text-align: center;
    line-height: 44px;
    font-size: 22px;
    color: $primary-btn-color;
    cursor: pointer;
}
</style>